import { useEffect } from "react";
import { useSearchParams } from "wouter";

/**
 * Public entry point for Openserve dispute report links. No Clerk gate — the
 * signed token is validated server-side when we redirect to the API HTML view.
 */
export function DisputePublicReport() {
  const [params] = useSearchParams();
  const token = params.get("token")?.trim() ?? "";

  useEffect(() => {
    if (!token) return;
    const apiPath = `/api/disputes/public-report?token=${encodeURIComponent(token)}`;
    window.location.replace(apiPath);
  }, [token]);

  if (!token) {
    return (
      <div className="min-h-[100dvh] flex items-center justify-center bg-gray-50 p-8">
        <p className="text-sm text-slate-600 text-center max-w-md">
          This link is invalid or missing a security token. Request a new
          shareable link from Mooya.
        </p>
      </div>
    );
  }

  return (
    <div className="min-h-[100dvh] flex items-center justify-center bg-gray-50 p-8">
      <p className="text-sm text-slate-500">Opening report…</p>
    </div>
  );
}
